<template>
    <div class="col-md-3 mb-4" v-if="currentUserMap">
        <img :src="currentUserMap.image_url" :alt="currentUserMap.title ? currentUserMap.title.rendered : ''" class="img-fluid">
        <span class="text-center text-black font-bold d-block font-italic">{{ currentUserMap.designation }}</span>
        <span class="text-center text-normal font-bold d-block">{{ currentUserMap.title ? currentUserMap.title.rendered : '' }}</span>
    </div>
</template>

<script>
export default {
    name: 'ExecImageDetails',
    props: ['currentUserMap']
}
</script>